import { createActionGroup, props } from '@ngrx/store';

export const loadersActions = createActionGroup({
    source: 'Loaders',
    events: {
        Add: props<{ id: string }>(),
        Delete: props<{ id: string }>(),
    },
});
